export default __webpack_public_path__ + "static/media/slab2.7b1d9999.png";